import React, { useEffect } from "react";
import { View, ActivityIndicator } from "react-native";
import { useNavigation } from "@react-navigation/native";
import Constants from "expo-constants";
import AppText from "../../components/AppText";

const AppleCallbackPage: React.FC = () => {
  const navigation = useNavigation();
  const api_url = Constants.expoConfig?.extra?.API_URL;
  
  console.log("AppleCallbackPage: received code", api_url);
  useEffect(() => {
    console.log("AppleCallbackPage: useEffect triggered");
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code") ?? "";
    if (!code) return;

    const fetchAppleUser = async () => {
      try {
        const response = await fetch(
          `${api_url}portal/auth/exchange`,
          {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: new URLSearchParams({ code })}
        );

        const data = await response.json();
        console.debug("AppleCallback: exchange response", data);

        if (data) {
          // Redirect to SignIn and hand over the exchange response.
          try {
            (navigation as any).navigate("SignIn", { appleData: data });
            return;
          } catch (navErr) {
            console.warn("AppleCallback: navigation to SignIn failed", navErr);
          }
        }
      } catch (err) {
        console.error("AppleCallback: exchange failed", err);
      }
    };

    fetchAppleUser();
  }, [navigation]);

  return (
    <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
      <ActivityIndicator />
      <AppText>Fetching your Apple account info...</AppText>
    </View>
  );
}

export default AppleCallbackPage;
